import bootstrap from '../bootstrap';
import 'react-hot-loader'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, createRouterPlugin } from '@souche-f2e/muji';
import Root, { router } from './Root';
import store from './store';

const init = async () => {
  store.use(createRouterPlugin(router));
  store.init();
  if (typeof bootstrap === 'function') {
    await bootstrap();
  }
  router.init();
}

const App = () => (
  <Provider store={store}>
    <Root />
  </Provider>
);

const render = () => {
  ReactDOM.render(
    <App />,
    document.getElementById('root'),
  );
};

init()
  .then(() => {
    render();
  })
  .catch((err) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(err);
    }
  });
